import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {TaskMenuDetails} from '@features/task-manager/models/task-manager.model';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {take} from 'rxjs/operators';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';

@Component({
    standalone: false,
    selector: 'app-task-assigned-to-cell-viewer',
  templateUrl: './task-assigned-to-cell-viewer.component.html',
  styleUrls: ['./task-assigned-to-cell-viewer.component.scss']
})
export class TaskAssignedToCellViewerComponent implements OnInit, CellComponent, OnDestroy {

  fieldDefinition: FieldDefinition;
  taskInfo: any;
  item: any;
  displayText: string;
  assignedRolesDisplayText: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private taskManagerService: TaskManagerService) {
  }

  ngOnInit(): void {
    this.displayText = '';
    this.assignedRolesDisplayText = 'Assign Roles';

    if (this.item.cells['Task']) {
      this.taskInfo = this.item.cells['Task'].value;
      if (this.taskInfo.assignedRoles && this.taskInfo.assignments.length) {
        for (let i = 0; i < this.taskInfo.assignments.length; i++) {
          // console.log('Task Info');
          // console.log(this.taskInfo.assignments[i]);
          this.displayText += `${this.taskInfo.assignments[i].user.firstName} ${this.taskInfo.assignments[i].user.lastName}`;
          if (i < this.taskInfo.assignments.length - 1) {
            this.displayText += ', ';
          }
        }
      }

      // todo: work with role
      if (this.taskInfo.assignedRoles && this.taskInfo.assignedRoles.length) {
        for (let i = 0; i < this.taskInfo.assignedRoles.length; i++) {
          this.displayText += `, ${this.taskInfo.assignedRoles[i].roleName}`;
        }
      }
    }
  }

  onClick(menuId: string) {
    this.openCertainMenuInTask(menuId);
  }

  private openCertainMenuInTask(menuId: string) {
    const task = this.taskInfo;
    const taskMenuDetails = new TaskMenuDetails();
    taskMenuDetails.id = menuId;
    if (task && task.ticketId && task.boardScope) {
      this.taskManagerService.openTaskByTaskId(task.ticketId, GraphqlContentScope.getScope(task.boardScope), null, null,
        taskMenuDetails, false)
        .pipe(take(1)).subscribe(state => {
        this.valueChanged.emit({
          item: this.item,
          fieldDefinition: this.fieldDefinition,
          action: {id: 'TaskClosed'},
          updatedState: state
        });
      });
    }
  }

  ngOnDestroy(): void {
  }
}
